import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';

import * as S from './styles';
import TitleNavBarContext from 'context/TitleNavBarContext';
import { useTranslation } from 'react-i18next';
import { UseTranslationProps } from 'types/UseTranslationProps';
import AddBtn from 'components/AddBtn';
import FormBannerCarousel from 'components/FormBannerCarousel';
import { BannersCarroselProps } from 'types/BannersCarroselProps';
import ListBanners from 'components/ListBanners';
import { getBanners, deleteBannerReq } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import Load from 'components/Load';

export default function BrandBanners() {
	const { i18n }: UseTranslationProps = useTranslation();
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [isFormOpen, setIsFormOpen] = useState(false);
	const [listBanners, setListBanners] = useState<BannersCarroselProps[]>([]);
	const [bannerToEdit, setBannerToEdit] = useState<BannersCarroselProps | null>(
		null
	);
	const [isLoad, setIsLoad] = useState(false);

	function getBannerToEdit(banner: BannersCarroselProps) {
		setBannerToEdit(banner);
		setIsFormOpen(true);
	}

	async function deleteBanner(banner: BannersCarroselProps) {
		setIsOpenLoad(true);
		setMessage('Deletando banner...');

		const { isSuccess } = await deleteBannerReq(banner.id, handleNotify);

		if (isSuccess) {
			const newList = listBanners.filter((item) => item.id !== banner.id);
			setListBanners(newList);
		}

		setIsOpenLoad(false);

		return isSuccess;
	}

	//busca lista de banners
	useEffect(() => {
		(async () => {
			const { isSuccess, list } = await getBanners(setIsLoad, handleNotify);
			if (isSuccess) {
				setListBanners(list);
			}
		})();
	}, []);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({
			...value,
			title: 'Lista de banners de marcas'
		}));
	}, [i18n?.language]);

	return (
		<S.container>
			<AddBtn
				anyFunction={() => {
					setIsFormOpen(true);
				}}
				text="Adicionar banner"
			/>
			{isLoad ? (
				<S.centralize>
					<Load showText text="Buscando banners" />
				</S.centralize>
			) : (
				<ListBanners
					list={listBanners}
					getBannerToEdit={getBannerToEdit}
					deleteBanner={deleteBanner}
				/>
			)}
			{isFormOpen && (
				<FormBannerCarousel
					isOpenForm={isFormOpen}
					setIsOpenForm={setIsFormOpen}
					bannerToEdit={bannerToEdit}
					setBannerToEdit={setBannerToEdit}
					setListBanners={setListBanners}
					listBanners={listBanners}
				/>
			)}
		</S.container>
	);
}
